/**
 * @deprecated This file is deprecated and should no longer be used or modified.
 * Please use shared UI adapters instead.
 */
class ThirdPartyAdapter {
  locale;
  category;
  sourceName;
  type;
  apiKey;
  constructor(locale) {
    this.locale = locale;
  }
  toEssResult(predictionDescription, placeId, index) {
    const displayName = predictionDescription;
    let primaryDisplayName = '';
    let secondaryDisplayName = '';
    const parts = (displayName || '').split(',');
    if (parts.length < 2) {
      primaryDisplayName = parts[0].trim();
    } else {
      primaryDisplayName = parts[0];
      secondaryDisplayName = parts.slice(1).map(word => word.trim()).join(', ').trim();
    }
    return {
      category: this.category,
      coordinates: undefined,
      index,
      regionNames: {
        displayName,
        fullName: predictionDescription,
        lastSearchName: predictionDescription,
        primaryDisplayName,
        secondaryDisplayName
      },
      sourceId: placeId,
      sourceName: this.sourceName,
      type: this.type
    };
  }
}
export { ThirdPartyAdapter };